import { Benefit, Bonus, Faq, Module, PopupSale, Testimonial } from '../types/sales'

export const CHECKOUT_URL = 'https://yin-yoga-pro.impultienda.ar/checkout'
export const OFFER_ANCHOR = '#offre'

export const boxImage =
  'https://cdn.magicpatterns.com/uploads/nrcTWvz4HwLC6nBt8i21wa/Diseno_sin_titulo-3.png'

export const previewImages: { src: string; alt: string }[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/tmy44drvk52D27BXFQehFP/Captura_de_pantalla_2026-09-06_a_la(s)_7.21.54_p._m..png',
    alt: 'Fiche visuelle Butterfly — Papillon : zones, maintien, supports, entrée et sortie',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2Wfwf8MsLQGnP6SrixuUNt/Captura_de_pantalla_2026-09-06_a_la(s)_7.22.09_p._m..png',
    alt: 'Fiche Half Butterfly — options et changement de côté',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5AGmikzGuK6p64HV4p645T/Captura_de_pantalla_2026-09-06_a_la(s)_7.22.35_p._m..png',
    alt: 'Fiche Sleeping Swan — adaptations avec supports',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5PftB4iGrWKUYAVJBV84A7/Captura_de_pantalla_2026-09-06_a_la(s)_7.23.13_p._m..png',
    alt: 'Fiche Legs Up The Wall — jambes au mur, distances et soutien',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iF9HTUozq8e3ozp2BZwPUJ/Captura_de_pantalla_2026-09-06_a_la(s)_7.23.32_p._m..png',
    alt: 'Fiche Melting Heart — cœur fondant, zones, supports et options',
  },
]

export const whatIfQuestions = [
  'Quelles postures choisir aujourd’hui ?',
  'Comment construire une séquence cohérente ?',
  'Comment varier vos cours sans toujours reprendre les mêmes structures ?',
  'Quelle adaptation proposer lorsqu’une posture ne convient pas ?',
  'Comment organiser vos prochaines semaines sans repartir de zéro ?',
]

export const painItems = [
  'Bibliothèque visuelle de postures.',
  'Séquences prêtes à enseigner.',
  'Système de création de séances.',
  'Adaptations & variations.',
  'Séances par objectif et thématique.',
  'Outils de planification professionnelle.',
  'Transitions structurées.',
  'Ressources prêtes à utiliser.',
]

export const readyItems = [
  'Besoin d’une bibliothèque visuelle de postures ? Elle est là.',
  'Besoin d’une séquence prête à enseigner ? Elle est là.',
  'Besoin de construire rapidement votre propre séance ? C’est prévu.',
  'Adaptations & variations ?',
  'Séances par objectif et thématique ?',
  'Organisation professionnelle de vos cours ?',
]

export const systemChecks = [
  'Bibliothèque visuelle de postures',
  'Séquences structurées',
  'Modèles de création de séances',
  'Variations & adaptations',
  'Séances par objectif',
  'Outils de planification',
  'Ressources professionnelles prêtes à utiliser',
]

export const modules: Module[] = [
  {
    n: 1,
    title: 'BIBLIOTHÈQUE VISUELLE DES POSTURES™',
    paras: [
      'Accédez à une bibliothèque visuelle et organisée des principales postures de Yin Yoga avec installation, zones principalement sollicitées, temps de maintien indicatifs, entrées et sorties, supports, variantes, adaptations et transitions.',
      'Utilisez des fiches visuelles structurées pour sélectionner rapidement les postures pertinentes pour votre prochaine séance.',
    ],
    close: 'Trouvez la posture. Consultez les options. Préparez.',
  },
  {
    n: 2,
    title: 'SÉQUENCES PRÊTES À ENSEIGNER™',
    paras: [
      'Travaillez avec des séquences structurées pour différentes durées, zones corporelles et orientations de séance.',
    ],
    close: 'Choisissez la séquence. Préparez le matériel. Enseignez.',
  },
  {
    n: 3,
    title: 'CRÉATEUR DE SÉANCES YIN YOGA™',
    paras: [
      'Utilisez un système organisé pour définir l’intention, sélectionner les zones corporelles, choisir les postures, organiser leur ordre, prévoir les transitions et adapter la durée de votre séance.',
      'Des modèles de préparation et des structures réutilisables vous permettent de créer vos propres cours avec davantage de cohérence.',
    ],
    close: 'Choisissez. Assemblez. Structurez.',
  },
  {
    n: 4,
    title: 'ADAPTATIONS & VARIATIONS™',
    paras: [
      'Accédez à des variations de postures, des options avec supports et des alternatives permettant de proposer différentes possibilités pendant vos séances.',
      'Utilisez bolster, briques, sangles, couvertures et autres supports de manière structurée pour préparer différentes options.',
    ],
    close: 'Observez. Adaptez. Proposez une option.',
  },
  {
    n: 5,
    title: 'SÉANCES PAR OBJECTIF & THÉMATIQUE™',
    paras: [
      'Utilisez des ressources organisées autour de différents objectifs et orientations : hanches, colonne, chaîne postérieure, haut du corps, corps entier, pratiques douces, matin, soir et autres thématiques.',
      'Passez directement de l’objectif choisi à une structure claire comprenant postures, ordre, temps, supports et variations.',
    ],
    close: 'Choisissez l’objectif. Ouvrez la structure. Enseignez.',
  },
  {
    n: 6,
    title: 'SYSTÈME PROFESSIONNEL D’ENSEIGNEMENT™',
    paras: [
      'Organisez votre planification hebdomadaire et mensuelle, la rotation des thématiques, votre bibliothèque personnelle de séances et vos ressources réutilisables.',
      'Utilisez des fiches de préparation, calendriers, checklists et outils de suivi pour garder vos cours organisés semaine après semaine.',
    ],
    close: 'Planifiez. Organisez. Réutilisez.',
  },
]

export const bonuses: Bonus[] = [
  {
    n: 1,
    title: 'GUIDE DE CUES & CONSIGNES POUR PROFESSEURS DE YIN YOGA™',
    subtitle: 'Bibliothèque de langage prête à utiliser',
    paras: [
      'Accédez à des formulations professionnelles pour guider l’installation, le maintien, les adaptations, les transitions, les sorties de posture et les différents moments de votre séance.',
      'Utilisez des cues organisés, mini-scripts et fiches de référence aux côtés du système principal.',
    ],
    close: 'Guidez. Accompagnez. Enseignez.',
  },
  {
    n: 2,
    title: 'PROPS & ADAPTATIONS TOOLKIT™',
    subtitle: 'Guide pratique des supports & variations',
    paras: [
      'Organisez l’utilisation des bolsters, briques, couvertures, sangles, coussins et du mur pour préparer différentes options selon les postures et les besoins observés pendant le cours.',
      'Utilisez des matrices, fiches de décision et ressources d’adaptation pour préparer votre matériel et vos alternatives.',
    ],
    close: 'Observez. Soutenez. Adaptez.',
  },
  {
    n: 3,
    title: 'YIN YOGA THEME & INTENTION PLANNER™',
    subtitle: 'Système professionnel de planification thématique',
    paras: [
      'Transformez une intention ou une thématique en direction claire pour votre prochaine séance sans chercher constamment de nouvelles idées.',
      'Utilisez des cartes d’intention, matrices, outils de planification et modèles permettant de construire un fil conducteur cohérent.',
    ],
    close: 'Choisissez le thème. Structurez l’intention. Enseignez.',
  },
  {
    n: 4,
    title: 'TEACHER CLASS ORGANIZER™',
    subtitle: 'Système de suivi & d’organisation des séances',
    paras: [
      'Organisez vos cours de la préparation au suivi avec des planificateurs, registres, fiches de séance, checklists et outils permettant de conserver ce qui fonctionne et préparer les semaines suivantes.',
      'Construisez progressivement une bibliothèque professionnelle de séances que vous pouvez classer, adapter et réutiliser.',
    ],
    close: 'Préparez. Enseignez. Notez. Réutilisez.',
  },
]

export const benefits: Benefit[] = [
  {
    icon: '🧘',
    title: 'Ressources visuelles prêtes à utiliser',
    text: 'Ouvrez le système et accédez à des ressources organisées au lieu de repartir de zéro.',
  },
  {
    icon: '📋',
    title: 'Séquences pratiques et structurées',
    text: 'Utilisez des postures, séquences, transitions et structures de cours dans un format clair.',
  },
  {
    icon: '🧩',
    title: '6 domaines essentiels',
    text: 'Gardez postures, séquences, création, adaptations, thématiques et planification organisées.',
  },
  {
    icon: '🔄',
    title: 'Ressources réutilisables',
    text: 'Revenez aux séquences, fiches et outils chaque fois que vous préparez vos prochains cours.',
  },
  {
    icon: '📂',
    title: 'Bibliothèque professionnelle organisée',
    text: 'Arrêtez de chercher dans des notes, captures d’écran, documents et ressources dispersées.',
  },
  {
    icon: '⏱️',
    title: 'Moins de préparation',
    text: 'Passez moins de temps à chercher et organiser vos ressources avant chaque séance.',
  },
]

export const offerChecks = [
  '6 modules professionnels',
  '4 bonus professionnels',
  'Bibliothèque visuelle de postures',
  'Séquences structurées',
  'Variations & adaptations',
  'Ressources thématiques',
  'Outils de planification',
  'Organisation professionnelle des séances',
]

export const testimonials: Testimonial[] = [
  {
    name: 'Claire Fontaine',
    role: 'Professeure de Yin Yoga, 200h',
    location: 'Lyon, France',
    quote:
      'Je passais facilement deux heures à préparer un cours de 75 minutes : chercher les postures, vérifier les temps de maintien, noter les adaptations. Depuis que j’utilise la bibliothèque visuelle et les séquences prêtes à enseigner, je prépare en vingt minutes. Les fiches sont claires, et je retrouve immédiatement les entrées, sorties et supports pour chaque posture.',
  },
  {
    name: 'Marie-Josée Tremblay',
    role: 'Professeure de yoga et propriétaire de studio',
    location: 'Québec, Canada',
    quote:
      'Ce qui a changé pour moi, c’est le Module 6. J’enseigne huit cours par semaine et je tournais toujours autour des mêmes structures. Avec la planification mensuelle et la rotation des thématiques, mes séances sont variées sans que j’aie à réinventer quoi que ce soit. Mes élèves l’ont remarqué avant moi.',
  },
  {
    name: 'Sophie Berger',
    role: 'Professeure de Yin & Hatha, 12 ans d’expérience',
    location: 'Genève, Suisse',
    quote:
      'Le module Adaptations & Variations est celui que j’ouvre le plus. J’ai des groupes très mixtes, de 25 à 70 ans, et je devais improviser les options avec bolster ou brique. Maintenant j’arrive en cours avec deux ou trois alternatives déjà prévues par posture. Je me sens beaucoup plus posée quand quelqu’un ne peut pas entrer dans une forme.',
  },
  {
    name: 'Nathalie Aubry',
    role: 'Professeure de Yin Yoga en entreprise',
    location: 'Bruxelles, Belgique',
    quote:
      'Je donne des séances de 45 minutes en entreprise et je dois adapter à chaque groupe. Les séances par objectif — hanches, colonne, chaîne postérieure, soir — me permettent de choisir une direction en quelques secondes. Le guide de cues m’a aussi aidée à raffiner mon langage pendant les longs maintiens.',
  },
  {
    name: 'Élodie Marchand',
    role: 'Professeure de yoga indépendante',
    location: 'Nantes, France',
    quote:
      'Je suis passée de notes éparpillées dans trois carnets et un téléphone plein de captures d’écran à une seule bibliothèque organisée. Le créateur de séances m’a surtout appris à structurer mes propres cours : intention, zones, ordre, transitions. Je construis maintenant mes séquences moi-même, avec beaucoup plus de cohérence.',
  },
]

export const faqs: Faq[] = [
  {
    q: 'Est-ce un produit physique ?',
    a: 'Non. YIN YOGA PRO™ est une ressource professionnelle 100 % numérique.',
  },
  {
    q: 'À qui s’adresse ce système ?',
    a: 'Aux professeurs de yoga et de Yin Yoga qui recherchent des ressources organisées, visuelles et prêtes à utiliser pour préparer leurs séances.',
  },
  {
    q: 'Est-ce une certification ou une formation ?',
    a: 'Non. Il s’agit d’une ressource professionnelle de préparation et de référence, et non d’une certification ou d’un substitut à une formation professionnelle requise.',
  },
  {
    q: 'Est-ce encore un ebook rempli de théorie ?',
    a: 'Non. Le système principal se concentre sur des postures visuelles, séquences structurées, adaptations, ressources thématiques et outils prêts à utiliser.',
  },
  {
    q: 'Dois-je créer moi-même les séquences et les ressources ?',
    a: 'Non. Les ressources sont déjà créées et organisées. Vous sélectionnez et adaptez les éléments appropriés selon votre séance, votre groupe et votre jugement professionnel.',
  },
  {
    q: 'Quels domaines sont inclus ?',
    a: 'Bibliothèque Visuelle des Postures, Séquences Prêtes à Enseigner, Créateur de Séances Yin Yoga, Adaptations & Variations, Séances par Objectif & Thématique et Système Professionnel d’Enseignement.',
  },
  {
    q: 'Puis-je utiliser les ressources avec différents groupes ?',
    a: 'Les ressources fournissent des structures générales pouvant être utilisées comme références et adaptées par le professeur selon le contexte, les participants et son jugement professionnel.',
  },
  {
    q: 'Les ressources sont-elles prêtes à utiliser ?',
    a: 'Oui. Le système comprend des ressources visuelles conçues pour une consultation et une préparation pratiques au format numérique.',
  },
  {
    q: 'Est-ce que des ressources de planification et d’organisation sont incluses ?',
    a: 'Oui. Les quatre bonus complémentaires comprennent des cues et consignes, des outils d’adaptation avec supports, un planner de thèmes et intentions et un système d’organisation des séances.',
  },
  {
    q: 'Est-ce lié à une méthode ou une certification spécifique ?',
    a: 'Non. Il s’agit d’une ressource professionnelle en français destinée à un marché international francophone et elle ne remplace pas une formation, une certification, les recommandations professionnelles applicables ou le jugement du professeur.',
  },
  {
    q: 'Comment vais-je recevoir le produit ?',
    a: 'Vous recevrez un accès numérique immédiat après votre achat.',
  },
]

export const popupSales: PopupSale[] = [
  { name: 'Camille D.', city: 'Paris', country: 'France' },
  { name: 'Sophie L.', city: 'Lyon', country: 'France' },
  { name: 'Émilie R.', city: 'Bordeaux', country: 'France' },
  { name: 'Julie M.', city: 'Marseille', country: 'France' },
  { name: 'Amélie B.', city: 'Nantes', country: 'France' },
  { name: 'Claire T.', city: 'Toulouse', country: 'France' },
  { name: 'Manon P.', city: 'Lille', country: 'France' },
  { name: 'Céline V.', city: 'Strasbourg', country: 'France' },
  { name: 'Chloé G.', city: 'Montpellier', country: 'France' },
  { name: 'Laure S.', city: 'Rennes', country: 'France' },
  { name: 'Aurélie N.', city: 'Nice', country: 'France' },
  { name: 'Élodie F.', city: 'Annecy', country: 'France' },
]
